<template>
  <div class="rcp-screen">
    <recipes-tools v-if="ctl.hasData"></recipes-tools>
    <recipes-notes v-if="ctl.hasData"></recipes-notes>
    <recipes-state v-if="ctl.stateKind" :kind="ctl.stateKind"></recipes-state>
    <div v-else class="rcp-grid" :style="{ '--rcp-min': `${ctl.cardMinWidth}px` }">
      <recipe-card v-for="entry in ctl.visibleCards" :key="entry.c.name" :c="entry.c" :rows="entry.rows" :query="entry.q"></recipe-card>
    </div>
    <recipes-zero-note v-if="ctl.hasData"></recipes-zero-note>
  </div>
</template>

<script>
import RecipeCard from "../parts/RecipeCard.vue";
import RecipesNotes from "../parts/RecipesNotes.vue";
import RecipesState from "../parts/RecipesState.vue";
import RecipesTools from "../parts/RecipesTools.vue";
import RecipesZeroNote from "../parts/RecipesZeroNote.vue";

/** "Po jelima": kartice jela u kolonama (kratka kartica ne ostavlja prazninu), sa izmjenom porcija po smjenama. */
export default {
  name: "RecipesByMeal",
  components: { RecipeCard, RecipesNotes, RecipesState, RecipesTools, RecipesZeroNote },
  inject: { ctl: "recipesCtl" },
};
</script>
